import React, { ComponentProps } from 'react';
import { asView } from '../../../_lib/ViewFetcher';
import { PageLeadUser } from '../../../_lib/components/PageLead';

function UserPageLeadDefault({ title, honorificPrefix }: PageLeadUser) {
  return <PageLeadUser title={title} honorificPrefix={honorificPrefix} />;
}

export const UserPageLeadDefaultView = asView(UserPageLeadDefault);
export type UserPageLeadDefaultView = ComponentProps<typeof UserPageLeadDefaultView>;
